export default import.meta.ROLLDOWN_FILE_URL_hVI9PDLUKQk5OD$vTtc9yA